import { connect } from "react-redux";
import { ClipboardIcon } from "@heroicons/react/20/solid";
import Tooltip from "@/tooltip";
import { copyToClipboard } from "@/helpers/ClipboardHelpers";

function CopyID({ view, id, isAdmin }) {
    if (!isAdmin) return null;

	const copy = () => copyToClipboard(id);
	return (
		<div
			className="btn btn-xs btn-default"
			style={{ display: "block", width: "fit-content", marginTop: view === "Card" ? undefined : 7 }}
			type="button"
			onClick={copy}
		>
			<Tooltip
				content={"Copy ID"}
				arrowSize={4}
			>
				<ClipboardIcon
					className="h-5 w-5 text-dark-gray"
					style={view === "Card" ? { verticalAlign: "middle", marginRight: 2 } : { marginTop: 4 }}
				/>
				{view === "Card" ? "Copy ID" : null}
			</Tooltip>
		</div>
	);
}


const mapStateToProps = (state) => {

	return {
        isAdmin: state.my.profile.isAdmin,
	};
};

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(CopyID);
